module.exports = __webpack_public_path__ + "static/heroes-for-my-son-c3f7bc5f41e820ca894d02043a1237cc.jpg";